import apiClient from './apiClient';

// Guest App management — backed by the adapter API at /api/v1/settings/guest-book*
// (camelCase payloads, no trailing slashes). The /app endpoint bundles the
// share links, per-tile feature toggles, help-card contact, branding fields
// and the check-in payment policy into one config object; sections keep
// their own CRUD endpoints.
const guestAppService = {
  getConfig: () => apiClient.get('/v1/settings/guest-book/app'),
  updateConfig: (data) => apiClient.put('/v1/settings/guest-book/app', data),

  getSections: () => apiClient.get('/v1/settings/guest-book'),
  createSection: (data) => apiClient.post('/v1/settings/guest-book', data),
  updateSection: (slug, data) => apiClient.put(`/v1/settings/guest-book/${slug}`, data),
  deleteSection: (slug) => apiClient.del(`/v1/settings/guest-book/${slug}`),
  reorderSections: (orderedSlugs) =>
    apiClient.post('/v1/settings/guest-book/reorder', { ordered_slugs: orderedSlugs }),

  uploadLogo: (file) => {
    const form = new FormData();
    form.append('logo', file);
    return apiClient.postForm('/v1/settings/guest-book/branding/logo', form);
  },
  deleteLogo: () => apiClient.del('/v1/settings/guest-book/branding/logo'),
};

export default guestAppService;
